/**
 * useFirms — Firms list hook with cross-tab synced cache.
 *
 * Backend: `GET /api/firms/` → `{ success, data: [...] }`
 *
 * Tüm sayfalardaki "firma seç" dropdown'ları için tek kaynak:
 *   const { firms, loading, refresh } = useFirms();
 *   invalidateFirms();  // Firma ekleme/silme sonrası mutation tarafından çağrılır
 *
 * Cross-tab senkron: bir sekmede Firms sayfasından firma eklenince,
 * Users / SendNotification / vb. dropdown'lar diğer açık sekmelerde
 * BroadcastChannel ile anında güncellenir.
 */
import api from './api';
import { createSharedCache } from './createSharedCache';

const { useShared, invalidate } = createSharedCache({
  channel: 'firms-cache',
  // /firms hem `data.data` hem `data.firms` döndüren legacy şemalara karşı
  // toleranslı — eski sayfalar her iki şemayı da kullanıyor.
  fetcher: () => api.get('/firms/').then((r) => r.data?.data || r.data?.firms || []),
});

export function useFirms() {
  const { data, loading, refresh } = useShared();
  return { firms: data, loading, refresh };
}

export const invalidateFirms = invalidate;
